import { SelfTestQuestion, SelfTestQuestionCollection } from "../../../../components/self-test/model/SelfTestQuestion";
import { result } from "./result";

export const questions: SelfTestQuestionCollection = {
    showProgressBarAfterIndex: 99,
    analytics: {
        slug: 'cholesterol',
        resultText: (answers) => {
            const r =  result(answers);
            return `gender-${r.gender}_risk-${r.risk ? 'high' : 'low'}`;
        },
    },
    questions: [
        {
            type: 'description',
            label: '開始',
            title: '一分鐘小測試<br/><br/>',
            content: '此測試可協助您作出初步評估。只需回答數條簡單選擇題，就可了解自己的情況。<br/><br/><br/>',
            image: 'self-test/cholesterol/q0.png',
            btnText: "開始評估",
        },
        {
            type: 'description',
            label: '開始',
            title: '在評估您的膽固醇水平前，請先告知我們您的基本資料：',
            image: 'self-test/cholesterol/q0a.png',
            btnText: "開始評估",
        },
        {
            type: 'multiple-choice',
            label: '基本資料 (一)',
            title: '您的性別是？',
            image: 'self-test/cholesterol/q0b.png',
            answers: [
                {
                    label: "男",
                    answer: "M",
                },
                {
                    label: "女",
                    answer: "F",
                }
            ]
        },
        {
            type: 'multiple-choice',
            label: '基本資料 (二)',
            title: '您知道自己的膽固醇水平嗎？',
            image: 'self-test/cholesterol/q0c.png',
            answers: [
                {
                    label: "知道",
                    answer: "A",
                },
                {
                    label: "不知道",
                    answer: "B",
                }
            ]
        },
        {
            type: 'description',
            label: '繼續評估',
            title: '你有膽固醇高問題嗎？<br/>',
            content: '以下問題可協助您有否高膽固醇風險作出初步評估。<br/><br/>',
            image: 'self-test/cholesterol/q0d.png',
            btnText: "繼續評估",
        },
        {
            type: 'multiple-choice',
            label: '基本資料 (三)',
            title: '您的年齡組別為<sup>10</sup>',
            image: 'self-test/cholesterol/q0e.png',
            answers: [
                {
                    label: "44歲或以下",
                    answer: "A",
                },
                {
                    label: "45至54歲",
                    answer: "B",
                },
                {
                    label: "55至64 歲",
                    answer: "C",
                },
                {
                    label: "65歲或以上",
                    answer: "D",
                }
            ]
        },
        {
            type: 'multiple-choice',
            label: '第一題',
            title: '您有運動的習慣嗎<sup>11</sup>？',
            image: 'self-test/cholesterol/q1.png',
            answers: [
                {
                    label: "經常",
                    answer: "A",
                },
                {
                    label: "間中",
                    answer: "B",
                },
                {
                    label: "沒有",
                    answer: "C",
                }
            ]
        },
        {
            type: 'multiple-choice',
            label: '第二題',
            title: '您/家人有糖尿病嗎<sup>12,13</sup>？',
            image: 'self-test/cholesterol/q2.png',
            answers: [
                {
                    label: "有",
                    answer: "A",
                },
                {
                    label: "沒有",
                    answer: "B",
                }
            ]
        },
        {
            type: 'multiple-choice',
            label: '第三題',
            title: '您家人有家族性高膽固醇血症嗎<sup>14</sup>？',
            image: 'self-test/cholesterol/q3.png',
            answers: [
                {
                    label: "有",
                    answer: "A",
                },
                {
                    label: "無",
                    answer: "B",
                }
            ]
        },
        {
            type: 'bmi',
            label: '第四題',
            title: '請輸入您的身高及體重，以計算出您的體重指標（BMI）為以下哪一組別<sup>15,16</sup>:',
            image: 'self-test/cholesterol/q4.png',
            expr: (BMI: number): string => {
                if (BMI >= 25) {
                    return "第一組別";
                } else if (BMI >= 23) {
                    return "第二組別";
                } else {
                    return "第三組別";
                }
            },
            answers: [
                {
                    label: "25或以上",
                    answer: "第一組別",
                },
                {
                    label: "23-24.9",
                    answer: "第二組別",
                },
                {
                    label: "23以下",
                    answer: "第三組別",
                }
            ]
        },
        {
            type: 'multiple-choice',
            label: '第五題',
            title: '您有吸煙的習慣嗎<sup>12</sup>？',
            image: 'self-test/cholesterol/q5.png',
            answers: [
                {
                    label: "有",
                    answer: "A",
                },
                {
                    label: "無",
                    answer: "B",
                }
            ]
        },
    ]
};
